exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.faq-area-content[data-v-5f17805e]{\n  width: 100%;\n}\n.faq-list[data-v-5f17805e] {\n  display: block;\n  width: 100%;\n}\n.faq-area-link[data-v-5f17805e] {\n  width: 100%;            /* 横幅を100%にして1カラムにする */\n  box-sizing: border-box;\n  padding-right: 0;       /* 1カラムなので右余白は不要（または適宜調整） */\n}\n", ""]);

// exports
